// extracted by mini-css-extract-plugin
export default {"coffeeCatalogMain":"CoffeeCatalogMain_coffeeCatalogMain__XoYQ1"};